<!--  -->
<template>
  <div>
    <div class="borwe">
      <!-- <div class="dwawq">
      <div class="waeawleft">
        <div class="wjkaeq">企业</div>
        <div
          class="company_name"
          :class="{ active: activeIndex === index }"
          v-for="item,index in companyarr"
          :key="index"
          @click="choosecompany(index,item.corp_id)"
        >
          {{item.corp_name}}
        </div>
      </div>
    </div> -->
      <div class="dwawq">
        <div class="waeawleft">
          <div class="wjkaeq">企业</div>
          <div class="company_name">
            {{ qiyename }}
          </div>
        </div>
      </div>
      <div
        v-loading="loading"
        style="position: relative;"
      >
        <div class="dwawq_two">
          <div class="waeawleft">
            <div class="wjkaeq">人员选择</div>
            <div class="container">
              <div
                v-for="item,index in arr"
                :key="index"
                class="item_box"
              >
                <div
                  class="select_box"
                  :class="[item.tips?'choose_blockr':'']"
                  @click="itenclick(item,index)"
                />
                <div
                  class="people_item"
                  @click="itenclick(item,index)"
                >{{ item.user_name }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="pagination_box">
          <el-pagination
            layout="prev, pager, next"
            :total="total"
            :page-size="50"
            small
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
      <div class="dwawq_three">
        <div class="waeawleft">
          <div class="wjkaeq">已选客服</div>
          <div class="container">
            <div
              v-for="itemr,index in arrs"
              :key="index"
              class="item_twobox"
            >
              <el-tag
                style="margin-right:10px;margin-bottom:5px"
                closable
                :type="itemr.type"
                @close="rightclick(itemr.user_id,index)"
              >
                {{ itemr.user_name }}
              </el-tag>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top:20px"><el-button
      type="primary"
      @click="sumbitr"
    >确定</el-button></div>
  </div>
</template>

<script>
import { getcorpList, getwechatcorpuser, updateCorpCsGroupal } from '@/api/workWechat.js'
export default {
  components: {},
  data() {
    return {
      type: null,
      activeIndex: null, // 存储当前选中的索引
      arr: [],
      arrs: [],
      loading: false,
      companyarr: [],
      query: {
        page: 1,
        pageSize: 50
      },
      total: null,
      corp_id: null,
      qiyename: '',
      chuanarr: [],
      group_name: '',
      group_id: ''
    }
  },
  created() {},
  mounted() {
    // for (let i = 0; i < 200; i++) {
    //   this.arr.push({
    //     user_name: `哈哈${i + 1}`,
    //     id: `${i + 1}`,
    //     tips: false,
    //     user_id: `${i + 1}`
    //   })
    // }
  },
  methods: {
    send(type, item) {
      this.type = type
      // eslint-disable-next-line eqeqeq
      if (this.type == 1) {
        console.log('新增')
      } else {
        console.log('编辑', item)
        this.qiyename = item.corp_name
        this.corp_id = item.corp_id
        this.group_name = item.group_name
        this.group_id = item.group_id
        this.arrs = []
        this.arrs = item.user_id_list.map((user_id, index) => ({
          user_id,
          user_name: item.user_names[index]
        }))
        console.log('this.arrs', this.arrs)
        this.namelist()
      }
      // this.corplist()
    },
    corplist() {
      getcorpList({
        page: 1,
        pageSize: 200
      }).then(res => {
        console.log('res', res)
        this.companyarr = res.data.list
      })
    },
    choosecompany(index, corp_id) {
      this.loading = true
      this.activeIndex = index
      this.corp_id = corp_id
      this.query.page = 1
      this.namelist()
    },
    namelist() {
      getwechatcorpuser({ ...this.query, corp_id: this.corp_id }).then(data => {
        console.log('res111', data.data.total)
        this.total = data.data.total
        data.data.list.forEach(item => {
          item.tips = false
        })
        this.arr = data.data.list
        this.arr.forEach(item => {
          this.arrs.forEach(items => {
            if (items.user_id === item.user_id) {
              console.log('items', item)
              item.tips = true
            }
          })
        })
        this.loading = false
      })
    },
    itenclick(item, index) {
      item.tips = !item.tips
      if (item.tips) {
        this.arrs.push({ user_id: item.user_id, user_name: item.user_name })
      } else {
        const index = this.arrs.findIndex(items => {
          return items.user_id === item.user_id
        })
        this.arrs.splice(index, 1)
      }
    },
    rightclick(user_id, index) {
      console.log(user_id, index)
      this.arrs.splice(index, 1)
      this.arr.findIndex(items => {
        if (items.user_id === user_id) {
          items.tips = false
        }
      })
    },
    handleCurrentChange(val) {
      this.query.page = val
      this.namelist()
    },
    sumbitr() {
      // eslint-disable-next-line eqeqeq
      if (this.arrs.length == 0) {
        return this.$message.error('请选择客服人员')
      }
      this.$confirm('是否提交', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.chuanarr = []
        this.chuanarr = this.arrs.map(item => {
          return item.user_id
        })
        console.log('this.chuanarr', this.chuanarr)
        updateCorpCsGroupal({
          user_id_list: this.chuanarr,
          group_id: this.group_id,
          group_name: this.group_name
        }).then(res => {
          if (res.message) {
            this.$message.warning(res.message)
          } else {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
          }
          if (res.data && res.data.fail && res.data.fail.length > 0) {
            // 有失败记录
            console.log('失败列表:', res.data.fail)
            // this.$message.error(`部分失败：${res.data.fail[0].message}`)
            this.$emit('updata', res.data.fail)
          } else {
            // 没有失败，说明全部成功
            // this.$message.success('修改成功')
            this.$emit('updata', [])
          }
        })
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.borwe {
  border: 1px solid #e6ebf2;
  border-radius: 10px;
  height: 500px;
  display: flex;
}
.dwawq {
  background: #f8f8f7;
  width: 130px;
  height: 100%;
  overflow-y: auto; /* 超出时显示滚动条 */
  scrollbar-width: thin; /* 适用于 Firefox */
  scrollbar-color: #ccc transparent; /* 滚动条颜色 */
  flex-shrink: 0;
}
.dwawq_two {
  /* background: pink; */
  width: 510px;
  height: 100%;
  overflow-y: auto; /* 超出时显示滚动条 */
  scrollbar-width: thin; /* 适用于 Firefox */
  scrollbar-color: #ccc transparent; /* 滚动条颜色 */
  flex-shrink: 0;
  padding-bottom: 40px;
  border-right: 1px solid #f8f8f7;
}
.dwawq_three {
  /* background: pink; */
  width: 100%;
  height: 100%;
  overflow-y: auto; /* 超出时显示滚动条 */
  scrollbar-width: thin; /* 适用于 Firefox */
  scrollbar-color: #ccc transparent; /* 滚动条颜色 */
}
.waeawleft {
  padding: 20px 20px 20px 20px;
}
.wjkaeq {
  color: #1d2129;
  font-size: 18px;
}
.company_name {
  margin-top: 13px;
  cursor: pointer;
}
.active {
  color: #165dff;
}
.container {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  margin-top: 6px;
}

.item_box {
  flex: 1 1 calc(33.33% - 10px); /* 确保每个 div 占 1/3 宽度 */
  max-width: calc(33.33% - 10px); /* 防止溢出 */
  /* background-color: lightblue; */
  text-align: center;
  /* padding: 20px; */
  margin: 5px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.item_twobox {
  flex: 1 1 calc(25% - 10px); /* 确保每个 div 占 1/4 宽度 */
  max-width: calc(25% - 10px); /* 防止溢出 */
  /* background-color: lightblue; */
  text-align: center;
  /* padding: 20px; */
  margin: 5px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.select_box {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
.choose_blockr {
  background: #409eff;
}
.pagination_box {
  position: absolute; /* 绝对定位到底部 */
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: white;
  padding: 10px;
  text-align: center;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.2);
}
.people_item {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}
</style>
